// extracted by mini-css-extract-plugin
module.exports = {"sort":"SortIcon_sort__2B9A-"};